var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vh-100"},[_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("__t")("You are now logged out.","auth__you-are-now-logged-out")))]),_c('layout-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }